<template>
  <div class="ranking">
    <ve-histogram
      width="1134px"
      :data="rankingData"
      :settings="settings"
      :extend="chartExtend"
      :legend-visible="false"
    ></ve-histogram>
  </div>
</template>

<script>
import { teamScore } from "@/api/projectPractice/analysis";

export default {
  data() {
    return {
      rankingData: {
        columns: ["teamName", "score"],
        rows: [],
      },
      settings: {
        // labelMap: { score: "分数" },
        // dataOrder: { label: "score", order: "asc" },
      },
      chartExtend: {
        series(v) {
          v.forEach((i) => {
            i.barWidth = 60;
          });
          return v;
        },
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$loading.show();
      teamScore({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.rankingData.rows = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ranking {
  text-align: left;
}
</style>